import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back.");
      const fallback =
        user.role === "admin" ? "/admin" :
        user.role === "staff" ? "/staff" : "/dashboard";
      const dest = loc.state?.from || fallback;
      nav(dest);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 md:grid-cols-2" data-testid="login-page">
      <div className="hidden md:flex bg-black text-white p-12 flex-col justify-between">
        <p className="font-mono text-xs tracking-widest text-white/60">TWINSTARS / PLAZA / LOGIN</p>
        <div>
          <h1 className="font-display text-5xl lg:text-7xl font-black tracking-tighter leading-[0.9]">
            Welcome back<br/>to the plaza.
          </h1>
          <p className="text-white/60 mt-6 max-w-sm">One account. Seven services. All bookings & wallet activity in one place.</p>
        </div>
        <p className="font-mono text-xs text-white/40">v1.0</p>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <h2 className="font-display text-3xl font-black tracking-tight">Sign in</h2>
          <div>
            <label className="label-eyebrow block mb-2">Email</label>
            <input data-testid="login-email" required type="email" className="input-sharp" value={email} onChange={(e)=>setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label-eyebrow block mb-2">Password</label>
            <input data-testid="login-password" required type="password" className="input-sharp" value={password} onChange={(e)=>setPassword(e.target.value)} />
          </div>
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full" type="submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-sm text-black/60">
            Don't have an account? <Link to="/register" className="underline" data-testid="login-to-register">Create one</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
